import { API } from "aws-amplify";
import { entityByNarwhal as entityByNarwhalGqlQuery } from "../graphql/queries";
import { GraphQLQuery } from "@aws-amplify/api";
import {
    EntityByNarwhalQuery,
    EntityByNarwhalQueryVariables,
    EntityByNarwhalResponse,
    EntityFeatures,
} from "../API";
import { useCallback } from "react"

export function useEntityByNarwhal() {
    const entityByNarwhal = useCallback(
        async (
            input: EntityByNarwhalQueryVariables
        ): Promise<
            Omit<Partial<EntityByNarwhalResponse>, "features"> & {
                features: Partial<EntityFeatures>;
            }
        > => {
            const result = await API.graphql<
                GraphQLQuery<EntityByNarwhalQuery>
            >({
                query: entityByNarwhalGqlQuery,
                variables: { ...input },
            });

            return {
                name: result.data?.entityByNarwhal?.name || "",
                enabled: result.data?.entityByNarwhal?.enabled || false,
                logo: result.data?.entityByNarwhal?.logo,
                features: {
                    guestCheckout:
                        result.data?.entityByNarwhal?.features.guestCheckout,
                    hasCards: result.data?.entityByNarwhal?.features.hasCards,
                    hasTipping: result.data?.entityByNarwhal?.features.hasTipping,
                    hasIBAN: result.data?.entityByNarwhal?.features.hasIBAN,
                    cardsSettings:
                        result.data?.entityByNarwhal?.features.cardsSettings,
                },
                type: result.data?.entityByNarwhal?.type || "",
            };
        },
        []
    );

    return { entityByNarwhal };
}
